import { types } from 'mobx-state-tree';

const ExperimentModel = types.model({
  id: types.string,
  activeVariant: types.optional(types.number, 0),
});

export default ExperimentModel;
